import { getDate, OpenLinkIcon} from '../../base'
import Rupee from '../Other/Rupee'
import { useNavigate } from 'react-router-dom'

function SingleInquiry({ inquiry }) {
    const navigate = useNavigate()

    return (
        <div className='singleOrder position-relative'>
            <div className='row'>
                <div className='col-4 col-md-6 col-lg-3'><span className='scolor'>Id </span>: AHWI-{inquiry.id}</div>
                <div className='col-8 col-md-6 col-lg-3'><span className='scolor'>Created on </span>: {getDate(inquiry.created_at)}</div>
                <div className='col-12 col-md-12 col-lg-6'><span className='scolor'>Completed </span>: {inquiry.is_done ? 'Yes' : 'No'}</div>
                <div className='col-12 col-md-9 col-lg-6 truncate-1'><span className='scolor'>Address </span>: {inquiry.delivery_address}</div>
                <div className='col-md-10 col-lg-6 truncate-1 d-none d-lg-flex'><span className='scolor'>Seller </span>: {inquiry.shop_name}</div>

                <div className=' col-7 col-md-3 col-lg-3'><span className='scolor'>Total Products </span>: {inquiry.total_item}</div>
                <div className='col-5 col-md-3 col-lg-3'><span className='scolor'>Paid </span>: {inquiry.is_paid ? 'Yes' : 'No'}</div>
                <div className='col-7 col-md-5 col-lg-3 d-flex  gap-2'><span className='scolor'>Grand Total </span>: <Rupee amount={inquiry.final_total_to_pay} /></div>
                <div className='col-5 col-md-4 col-lg-2 truncate-1'><span className='scolor'>Track  </span>: {inquiry.tracking_id ? '🚚' : 'No Id'}</div>
                <div className='col-11 d-lg-none truncate-1'><span className='scolor'>Seller </span>: {inquiry.shop_name}</div>
                <div className='smallText position-absolute d-flex flex-column align-items-center scolor' style={{ cursor: 'pointer', width: ' fit-content', bottom: '5px', right: '0px' }} onClick={() => navigate(`/inquiry/${inquiry.id}/details/`)}><OpenLinkIcon style={{ width: '16px' }} /> Detail</div>
            </div>
        </div>
    )
}

export default SingleInquiry